<div class="searchbar" [style]="cssClass">
  <img class="search-icon" src="../../../../assets/icons/lupa.svg" />
  <input
    *ngIf="auto"
    type="text"
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
    (input)="term.next($any($event).target.value)"
  />
  <input
    *ngIf="!auto"
    type="text"
    [placeholder]="placeholder"
    (input)="term.next($any($event).target.value)"
  />
</div>
